import React from "react";
import styles from "./PlaydateInviteBaseUnit.module.css";
import { PlaydateInvite, InviteStatus } from "../../gql/types";
import InfoTag, { TagVariant } from "./InfoTag";
import PlaydateInviteDetails from "./PlaydateInviteDetails";
import { inboundTopLeftLabelComputer } from "./inboundTopLeftLabelComputer";
import { resolveRSVPTags } from "./rsvpTagResolver";
import { outboundTopLeftLabelComputer } from "./outboundTopLeftLabelComputer";
import { inviteStatusTagComputer } from "./inviteStatusTagComputer";
import { voteStatusTagComputer } from "./voteStatusTagComputer";
import { inboundTagsResolver } from "./tags/inboundTagResolver";
import { outboundTagsResolver } from "./tags/outboundTagResolver";

interface Props {
    invite: PlaydateInvite;
}

const PlaydateInviteDetailsCard: React.FC<Props> = ({ invite }) => {
    let tags: Array<{ label: string, variant: TagVariant }> = [
    ];

    if (invite.guestUpdate) {
        tags = inboundTagsResolver(invite);
    }

    if (invite.organizerUpdate) {
        tags = outboundTagsResolver(invite);
    }

    return (
        <div className={styles.detailsCardContainer}>
            <div className={styles.tagRow}>
                {tags.map((tagData, idx) => (
                    <InfoTag
                        key={`${invite.inviteID}_${idx}`}
                        label={tagData.label}
                        variant={tagData.variant}
                    />
                ))}
            </div>
            <PlaydateInviteDetails
                invite={invite}
            />
        </div>
    );
};

export default PlaydateInviteDetailsCard;
